import { useEffect, useState } from 'react'

const SLIDE_INTERVAL_MS = 9000
const TRANSITION_MS = 900

/**
 * 單場輪播：每隔 SLIDE_INTERVAL_MS 自動左滑切到下一筆，循環播放。
 * items 若在背景被替換（例如定期刷新），只會影響「下一次」切換後顯示的內容，
 * 不會打斷目前正在畫面上的這一格（tick 只單向遞增，不受 items 變動重置）。
 */
export default function DashboardCarousel({ items, renderItem, emptyText }) {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => setTick((t) => t + 1), SLIDE_INTERVAL_MS)
    return () => clearInterval(timer)
  }, [])

  if (!items || items.length === 0) {
    return (
      <div className="h-full flex items-center justify-center">
        <span style={{ fontFamily: 'Noto Serif TC', fontSize: 20, color: 'rgba(188,49,61,0.4)', letterSpacing: '0.2em' }}>
          {emptyText}
        </span>
      </div>
    )
  }

  const index = tick % items.length
  const item = items[index]

  return (
    <div className="relative h-full overflow-hidden">
      <div
        key={index}
        className="h-full"
        style={{ animation: `dashboard-carousel-slide-in ${TRANSITION_MS}ms ease-out` }}
      >
        {renderItem(item, index)}
      </div>

      <style>{`
        @keyframes dashboard-carousel-slide-in {
          from { transform: translateY(60%); }
          to { transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
